import MUIDataTable from 'mui-datatables';
import { useDispatch, useSelector } from 'react-redux';
import { setPreview, setShowHistory } from '../../giftSlice';
import { Box, Chip, IconButton, Tab, Tooltip } from '@mui/material';
import { variants } from '../../../../variants/variants';
import { ArrowBack, ArrowRightAltRounded, PreviewOutlined } from '@mui/icons-material';
import { boxBackground, colors } from '../../utility/status';
import { TabContext, TabList } from '@mui/lab';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { toggleSwipe } from '../../../Search/searchSlice';
import CustomHistoryRow from './CustomHistoryRow';
import { Typography } from '@mui/material';
import { Stack } from '@mui/material';
import CustomEmptyTable from './CustomEmptyTable';
import UserAvatar from '../../../../common/UserAvatar';

const PreviousGift = ({ showEmployee, forms, defaultTab = 'Pass' }) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [result, setResult] = useState(defaultTab);
  const value = pathname.split('/gift/')[1];
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  let noData = Boolean(!forms[result] || forms[result]?.length === 0);
  const handleViewForm = (form) => {
    dispatch(
      setPreview({
        response: form.response,
        currentDesignation: form.currentDesignation,
        desiredDesignation: form.desiredDesignation,
        reason: form.reason,
      })
    );
  };
  const handleRowClick = (val, { dataIndex }) => {
    const form = forms[result][dataIndex];
    dispatch(toggleSwipe({ value: true }));
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'swipe', value: true }));
    handleViewForm({
      response: form.response,
      currentDesignation: form.currentDesignation,
      desiredDesignation: form.desiredDesignation,
      reason: form.reason,
    });
  };
  const columns = [
    { name: '_id', options: { display: false } },
    {
      name: 'employeeDetails',
      label: isMobile ? 'Application' : 'Employee',

      options: {
        sort: false,
        display: showEmployee ? (noData ? false : true) : false,
        customBodyRender: (val, tableMeta) => {
          const currentDesignation = tableMeta.rowData[2]?.split(' - ')[0];
          const desiredDesignation = tableMeta.rowData[3]?.split(' - ')[0];
          const row = tableMeta.rowData;
          return isMobile ? (
            <CustomHistoryRow gift={row} result={result} showEmployee={showEmployee} />
          ) : (
            <Stack direction={'row'} alignItems={'center'}>
              <UserAvatar src={val?.employeePhotoPath} sx={{ mr: 1 }} />

              <Box>
                <Typography sx={{ fontSize: variants.BODY }}>{val?.empName}</Typography>
                <Stack direction={'row'} alignItems={'center'}>
                  <Typography sx={{ fontSize: variants.TINY }}>{currentDesignation}</Typography>
                  <ArrowRightAltRounded />
                  <Typography sx={{ fontSize: variants.TINY }}>{desiredDesignation}</Typography>
                </Stack>
              </Box>
            </Stack>
          );
        },
      },
    },
    {
      name: 'currentDesignation',
      label: isMobile ? 'Application' : 'From',
      options: {
        filter: true,
        sort: false,
        display: showEmployee ? false : noData ? false : true,
        customBodyRender: (value, tableMeta) => {
          const row = tableMeta.rowData;
          return isMobile && !showEmployee ? (
            <CustomHistoryRow gift={row} result={result} showEmployee={showEmployee} />
          ) : (
            <Typography sx={{ fontSize: variants.BODY }}>{value.split(' - ')[0]}</Typography>
          );
        },
      },
    },
    {
      name: 'desiredDesignation',
      label: 'To',
      options: {
        filter: true,
        sort: false,
        display: isMobile ? false : noData ? false : true,

        customBodyRender: (value) => {
          return value.split(' - ')[0];
        },
      },
    },

    {
      name: 'submissionDate',
      label: 'Date of submission',
      options: {
        filter: false,
        sort: false,
        display: isMobile ? false : noData ? false : true,

        customBodyRender: (value) => {
          return new Date(value).toLocaleDateString();
        },
      },
    },
    {
      name: 'result',
      label: 'Result',
      options: {
        filter: true,
        sort: false,
        display: isMobile ? false : noData ? false : true,

        customBodyRender: (value) => {
          return (
            <Chip sx={{ background: boxBackground[value], color: colors[value], fontWeight: 700 }} label={value} />
          );
        },
      },
    },
    { name: 'reason', label: 'Reason', options: { display: false } },
    {
      name: 'response',
      label: 'Application',
      options: {
        filter: false,
        sort: false,
        display: isMobile ? false : noData ? false : true,

        customBodyRender: (value, tableMeta) => {
          return (
            <IconButton
              size='small'
              onClick={() =>
                handleViewForm({
                  response: value,
                  currentDesignation: tableMeta.rowData[2],
                  desiredDesignation: tableMeta.rowData[3],
                  reason: tableMeta.rowData[6],
                })
              }
            >
              <PreviewOutlined />
            </IconButton>
          );
        },
      },
    },
  ];
  const handleChange = (event, newValue) => {
    setResult(newValue);
  };
  const handleBackClick = () => {
    dispatch(setShowHistory({ value }));
    dispatch(setPreview({ reset: true }));
  };
  return (
    <Grid
      item
      xs={12}
      md={8}
      sx={{
        // height:`calc(100vh - ${isMobile?'185px':'130px'})`,
        height:`calc(100vh - 130px)`,
        background: isMobile ? '' : variants.boxBackground.PROFILE_CARD,
        borderRadius: variants.boxRadius.MAIN,
        overflow: 'hidden',
        [theme.breakpoints.down('lg')]: {
          px: 0,
          '& .MuiTableCell-footer': {
            p: 0,
            border: 0,
          },
        },
      }}
    >
      <Box
        sx={{
          border: 1,
          background: '#fff',
          borderColor: 'divider',
          borderRadius: variants.boxRadius.MAIN,
          overflow: 'hidden',
          m: isMobile ? 0 : 1,
          mt: 1,
        }}
      >
        <Tooltip title='back' placement='top' sx={{ m: 0 }}>
          <IconButton className={'backButton'} onClick={handleBackClick}>
            <ArrowBack fontSize='small' />
          </IconButton>
        </Tooltip>
        <TabContext value={result}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: isMobile ? 0 : 2 }}>
            <TabList onChange={handleChange}>
              {Object.keys(forms)?.map((res, index) => {
                return (
                  <Tab
                    sx={{ fontSize: variants.TINY, color: colors[res] }}
                    key={index}
                    label={
                      <span>
                        {res}
                        <span
                          style={{
                            marginLeft: '0.5rem',
                            paddingBlock: '0.15rem',
                            paddingInline: '0.75rem',
                            background: boxBackground[res],
                            borderRadius: 5,
                            color: colors[res],
                          }}
                        >
                          {(forms && forms[res]?.length) || 0}
                        </span>
                      </span>
                    }
                    value={res}
                  />
                );
              })}
            </TabList>
          </Box>
        </TabContext>
        <MUIDataTable
          title={null}
          data={forms[result]}
          columns={columns}
          options={{
            elevation: 0,
            selectableRows: false,
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 20],
            viewColumns: false,
            search: false,
            searchAlwaysOpen: true,
            download: false,
            filter: false,
            print: false,
            responsive: 'standard',
            onRowClick: isMobile ? handleRowClick : () => {},
            tableBodyHeight: `calc(100vh - ${isMobile ? '280px' : '300px'})`,
          }}
          components={{
            ...(noData && {
              TableBody: CustomEmptyTable,
            }),
          }}
        />
      </Box>
    </Grid>
  );
};

export default PreviousGift;
